/**
 * Uebersetzt die beiden Auswahlfelder der Produktuebersicht (Status, Zuordnung) in die Spalten der
 * Sicht `gambio.products_overview_ui`, gegen die gefiltert wird.
 *
 * Eigene Datei, weil genau hier zwei Fehler steckten, die man dem Aufruf nicht ansieht
 * (Betreiber-Meldung 20.09.2026, Migration 0364):
 *
 * 1. Status lief gegen `is_active`. Varianten-Kinder tragen in Gambio kein eigenes `isActive`, in
 *    der Sicht steht dort `null`, und `null` ist nicht `true` — also fiel jede Variante aus dem
 *    Filter. Im Pfannenshop wurden so 86 aktive, nicht zugeordnete Kinder unsichtbar und damit
 *    unzuordenbar. Richtig ist `effective_is_active` (eigener Wert, sonst der des Vaters).
 * 2. Zuordnung lief zeilenweise gegen `vario_article_number`. Der Betreiber will die Gruppe als
 *    Einheit sehen: „Es sollte immer der Variantenhauptartikel mit allen Varianten angezeigt
 *    werden. Die gehoeren dazu." Trifft irgendeine Zeile der Gruppe zu, kommt die ganze Gruppe —
 *    das leisten die `group_has_*`-Spalten.
 */

export type StatusFilter = '' | 'active' | 'inactive';
export type MappingFilter = '' | 'mapped' | 'unmapped' | 'in-vario';

/** Eine Bedingung `<column> is <value>` fuer die PostgREST-Abfrage. */
export interface FilterCondition { column: string; value: boolean }

/**
 * Die Bedingungen fuer einen Filterzustand. Leere Auswahl = keine Bedingung; die Reihenfolge ist
 * Status vor Zuordnung, damit die erzeugte Abfrage stabil bleibt.
 */
export function productFilterConditions(
  status: StatusFilter,
  mapping: MappingFilter,
): FilterCondition[] {
  const out: FilterCondition[] = [];
  if (status === 'active') out.push({ column: 'effective_is_active', value: true });
  else if (status === 'inactive') out.push({ column: 'effective_is_active', value: false });
  if (mapping === 'mapped') out.push({ column: 'group_has_mapped', value: true });
  else if (mapping === 'unmapped') out.push({ column: 'group_has_unmapped', value: true });
  else if (mapping === 'in-vario') out.push({ column: 'group_has_in_vario', value: true });
  return out;
}
